import { get } from 'lodash-es';
import { stripHtml } from 'client/utils/string-utils';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

const NUMBER_REGEX = /-?\d+(\.\d*)?/g;
const POSSIBLE_VERTICAL_ALIGN = ['top', 'middle', 'bottom'];
const TITLE_TAG_MAP = {
  ContentFragment,
};

const DEVICE = { true: 'Mobile', false: 'Wired' };

const removeHtml = str => stripHtml(str.replace(/&lt;/g, '<').replaceAll(/&gt;/g, '>'));
export const compareStrings = (a, b) => removeHtml(a).localeCompare(removeHtml(b));

export const compareValues = (a, b, isDescending) => {
  const getNumValue = val => {
    if (typeof val !== 'string') return val;

    const numStr = val.replace(/,/g, '');
    const match = numStr.match(NUMBER_REGEX);

    return match ? parseFloat(get(match, '[0]')) : null;
  };
  const floatA = getNumValue(a);
  const floatB = getNumValue(b);

  let compareValue;

  if (floatA && floatB) {
    compareValue = floatA - floatB;
  } else {
    compareValue = a < b ? -1 : 1;
  }

  return isDescending ? compareValue * -1 : compareValue;
};

export const getTablePropsFromContent = (content, isMobile) => {
  const title = content.metadata('title').value();
  const creativeId = content.metadata('creativeId').value() || undefined;
  const titleTag = content.metadata('titleTag').value('div');
  const TitleTag = TITLE_TAG_MAP[titleTag] || titleTag;
  const adName = content.metadata('adName').value();
  const articleClassName = content.metadata('articleClassName').value();
  const tableClassName = content.metadata('tableClassName').value();
  const stickyFirstColumn = content.metadata('stickyFirstColumn').boolean();

  const rowCount = content.metadata('rowCount').number();
  const columnCount = content.metadata('columnCount').number();
  const renderColumnHeader = new Array(columnCount)
    .fill()
    .some((_, index) => content.metadata(`columnHeader${index + 1}`).value());
  const columnCategories = content
    .metadata('columnCategories')
    .value()
    .split('||')
    .map(category => {
      const [value, colspan] = category.split('|');
      return { value, colspan: parseInt(colspan, 10) || 1 };
    })
    .filter(({ value }) => value);
  const columnCategoriesBackgrounds = content.metadata('columnCategoriesBackgrounds').value().split('|');

  const categoriesStartIndexes = [];
  columnCategories.forEach(({ colspan }) => {
    categoriesStartIndexes.push(get(categoriesStartIndexes, `[${categoriesStartIndexes.length - 1}]`, 0) + colspan);
  });
  const hasCategories = !!columnCategories.length;

  const columnHeaderBackgrounds = content.metadata('columnHeaderBackgrounds').value().split('|');

  const columnWidths = content.metadata('columnWidths').value().split('|');
  const fontSize = content.metadata('fontSize').value('1rem');
  const noVerticalBorders = content.metadata('noVerticalBorders').boolean();
  const noRowHeaders = content.metadata('noRowHeaders').boolean();
  const isStriped = content.metadata('striped').boolean();
  const isSmall = content.metadata('small').boolean();
  const columnsAlign = content.metadata('columnsAlign').value().split('|');
  const headersAlign = content.metadata('headersAlign').value().split('|');

  const verticalAlign = content.metadata('verticalAlign').value();
  const hasVerticalAlignment = POSSIBLE_VERTICAL_ALIGN.includes(verticalAlign);

  const logo = content.metadata('logo').value();
  const inlineLogo = content.metadata('inlineLogo').boolean();
  const oemClickOutBtnPosition = content.metadata('oemClickOutBtnPosition').value('bottom');
  const oemClickOutBtnColor = content.metadata('oemClickOutBtnColor').value('blue-30');
  const oemClickOutText = content.metadata(`oemClickOutText${DEVICE[isMobile]}`).value();
  const oemClickOutUrl = content.metadata(`oemClickOutUrl${DEVICE[isMobile]}`).value();
  const oemDisplayUrl = content.metadata('oemDisplayUrl').value();
  const disclaimer = content.metadata('disclaimer').value();

  return {
    title,
    creativeId,
    TitleTag,
    adName,
    articleClassName,
    tableClassName,
    stickyFirstColumn,
    rowCount,
    columnCount,
    renderColumnHeader,
    columnCategoriesBackgrounds,
    hasCategories,
    columnHeaderBackgrounds,
    columnWidths,
    fontSize,
    noVerticalBorders,
    isStriped,
    isSmall,
    noRowHeaders,
    columnsAlign,
    headersAlign,
    hasVerticalAlignment,
    categoriesStartIndexes,
    columnCategories,
    verticalAlign,
    logo,
    inlineLogo,
    oemClickOutBtnPosition,
    oemClickOutBtnColor,
    oemClickOutText,
    oemClickOutUrl,
    oemDisplayUrl,
    disclaimer,
  };
};
